import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

const ApiDocs = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">API Documentation</h1>
          <p className="text-sm text-gray-600">
            Endpoints públicos para integrações externas
          </p>
        </div>

        <div className="rounded-xl overflow-hidden border border-gray-200 shadow-sm bg-white">
          <SwaggerUI url={process.env.REACT_APP_SWAGGER_URL} />
        </div>
      </div>
    </div>
  );
};

export default ApiDocs;
